import {I18n} from 'react-redux-i18n';

import {stringUtils} from 'front-onceforall-core';

import {planPropTypes} from '../../../../utils/propTypes';

import {renderPriceUnit} from '../../utils';

const PlanFee = ({plan}) => (
  <div className="information-primary font-size-xs mt-3">
    {!plan.setupFee ?
      <>&nbsp;</> :
      stringUtils.getCurrency(I18n.t('subscriptions.plans.fee', {
        count: plan.setupFee,
        price: renderPriceUnit(plan.setupFee, plan.currency, 'none')
      }))
    }
  </div>
);

PlanFee.propTypes = {
  plan: planPropTypes().isRequired
};

export default PlanFee;
